const React = require("react");
const T = React.PropTypes;

const MetadataSpec = require("../types/MetadataSpec.js");
const MetadataSpecs = require("../MetadataSpecs.js");

const Locker = require("./Locker.jsx");

// All the forms
const CauditForm = require("./metadata/CauditForm.jsx");
const GeocodingImporterForm = require("./metadata/GeocodingImporterForm");
const MarketingURLForm = require("./metadata/MarketingURLForm.jsx");
const NexusForm = require("./metadata/NexusForm.jsx");
const PCardForm = require("./metadata/PCardForm.jsx");
const DivisionAssignmentsForm = require("./metadata/DivisionAssignmentsForm.jsx");
const HRContactAssignmentsForm = require("./metadata/HRContactAssignmentsForm");
const LegalCounselAssignmentsForm = require("./metadata/LegalCounselAssignmentsForm");
const PropertyAccountantAssignmentsForm = require("./metadata/PropertyAccountantAssignmentsForm.jsx");
const SrPropertyAccountantAssignmentsForm = require("./metadata/SrPropertyAccountantAssignmentsForm.jsx");
const SmartBonusForm = require("./metadata/SmartBonusForm.jsx");
const StoreBudgetsForm = require("./metadata/StoreBudgetsForm.jsx");
// ...add more forms here...

const outerStyle = {
    position: "relative", // To work with nested absolute elements
    backgroundColor: "#f5e781",
    padding: 15,
    borderBottom: "1px solid #efd77a",
    boxShadow: "1px 1px 5px #ccc"
};

const MetadataBox = React.createClass({
    propTypes:{
        Spec: MetadataSpec.Type.isRequired,
        IsLocked: T.bool,
        style: T.object
    },
    getDefaultProps() {
        return {
            style: {}
        };
    },
    render() {
        const style = Object.assign({}, outerStyle, this.props.style);

        const form = this.PickForm();

        return (<div style={style}>
            {this.props.IsLocked && (<Locker />)}
            {form}
        </div>);
    },
    PickForm() {
        switch(this.props.Spec.FormName)
        {
            case MetadataSpecs.FormNames.Caudit:
                return React.createElement(CauditForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.GeocodingImporter:
                return React.createElement(GeocodingImporterForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.MarketingURL:
                return React.createElement(MarketingURLForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.Nexus:
                return React.createElement(NexusForm, this.props.Spec.Data);
            case MetadataSpecs.FormNames.PCard:
                return React.createElement(PCardForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.DivisionAssignments:
                return React.createElement(DivisionAssignmentsForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.HRContactAssignments:
                return React.createElement(HRContactAssignmentsForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.LegalCounselAssignments:
                return React.createElement(LegalCounselAssignmentsForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.PropertyAccountantAssignments:
                return React.createElement(PropertyAccountantAssignmentsForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.SrPropertyAccountantAssignments:
                return React.createElement(SrPropertyAccountantAssignmentsForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.SmartBonus:
                return React.createElement(SmartBonusForm, this.props.Spec.Data)
            case MetadataSpecs.FormNames.StoreBudgets:
                return React.createElement(StoreBudgetsForm, this.props.Spec.Data)
            default:
                return (<div>A form is not defined for {this.props.Spec.FormName}.  Please contact support</div>)
        }
    }
});

module.exports = MetadataBox;


// WEBPACK FOOTER //
// ./src/components/MetadataBox.jsx